import styled from 'styled-components';
import COLORS from '@mlb/react-patterns/v4/style/universal.color';

import Button from '@mlb/react-patterns/v4/components/Button/button';
import { ButtonShapes, ButtonStyles } from '@mlb/react-patterns/v4/components/Button/button.types';
import Link from '@mlb/react-patterns/v4/components/Link/link';
import ModalWithAnimation from '@mlb/react-patterns/v4/components/ModalWithAnimation/modalWithAnimation';

const {
    mlbGrey1,
    blueRibbon,
    mlbWhite,
    mlbBlack
} = COLORS;

export const WhereToWatchModal = styled(ModalWithAnimation)``;

export const CloseButton = styled(Button)`
    position: absolute;
    top: 14px;
    right: 10px;
    height: 24px;
`;

export const Header = styled.header`
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    border-bottom: 1px solid ${mlbGrey1};
    text-align: center;
    padding: 16px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    overflow: hidden;
    word-wrap: normal;
    width: 80%;
`;

export const ButtonsWrapper = styled.section`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 16px 0;
`;

export const PartnerLink = styled(Link)`
    display: block;
    height: fit-content;
`;
export const PartnerButton = styled(Button).attrs({
    shape: ButtonShapes.PILL_SOLID
})`
    height: 48px;
    border-radius: 40px;
    font-size: 14px;
    width: 312px;
    background-color: ${blueRibbon};
`;

export const AudioButton = styled(Button).attrs({
    shape: ButtonShapes.HOLLOW,
    styleName: ButtonStyles.BLACK
})`
    height: 48px;
    border-radius: 40px;
    font-size: 14px;
    width: 312px;
    &:hover {
        color: ${mlbBlack};
        border-color: ${mlbBlack};
        background-color: ${mlbWhite};
        svg {
            fill: ${mlbBlack};
            path {
                fill: ${mlbBlack};
            }
        }
    }
`;

export const ContentRestrictionBody = styled.p`
    margin: 0;
    padding: 0 16px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    text-align: center;
`;
